import { Box, Breadcrumbs as MuiBreadcrumbs, styled, Typography } from '@mui/joy';
import { Link } from 'react-router-dom';

// Figma node 2796:10342 (Breadcrumbs).
export interface Crumb {
  label: string;
  to?: string;
}

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.vars.palette['hyperlink']['text'],
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '21.28px',
  textUnderlineOffset: '0.15em',
}));

const ACTIVE_TEXT_SX = {
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '21.28px',
  color: 'text.secondary',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export default function InsightsHubBreadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <Box
      sx={(theme) => ({
        px: 3,
        py: 1.5,
        backgroundColor: theme.palette.background.surface,
        borderBottom: `1px solid ${theme.palette.border.border}`,
      })}
    >
      <MuiBreadcrumbs
        separator='/'
        sx={{
          p: 0,
          ol: { flexWrap: 'nowrap', overflowX: 'auto', gap: '4px' },
          '& .MuiBreadcrumbs-separator': {
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '21.28px',
            color: 'text.secondary',
            mx: 0,
          },
        }}
      >
        <StyledLink to='/research-hub' sx={{ textWrap: 'nowrap' }}>
          Research hub
        </StyledLink>
        {items.map(({ label, to }, index) =>
          to && index < items.length - 1 ? (
            <StyledLink key={`${label}-${index}`} to={to} sx={{ textWrap: 'nowrap' }}>
              {label}
            </StyledLink>
          ) : (
            <Typography key={`${label}-${index}`} sx={ACTIVE_TEXT_SX}>
              {label}
            </Typography>
          )
        )}
      </MuiBreadcrumbs>
    </Box>
  );
}
